/**
 * Utilities for compact note headers across Dispatch + Field Notes.
 *
 * Why these live together: dispatch notes carry forward across multiple
 * dispatches of the same WO, and field notes do the same across visits.
 * Both need a tight "[Author] · [Date]:" prefix so techs can scan visits
 * without scrolling. Keep the formatting in one place so the popover, tech
 * card, and field-notes modal all look identical.
 */

/**
 * "Eric Schantz" -> "Eric S."
 * "Eric"        -> "Eric"
 * Empty/null    -> "—"
 *
 * Skips email addresses (returns the local-part untouched) so a system
 * fallback like "nate@absinc.com" doesn't get dotted.
 */
export function abbreviateName(name) {
  if (!name || typeof name !== "string") return "—";
  const trimmed = name.trim();
  if (!trimmed) return "—";
  if (trimmed.includes("@")) return trimmed.split("@")[0];
  const parts = trimmed.split(/\s+/);
  if (parts.length === 1) return parts[0];
  const first = parts[0];
  const last = parts[parts.length - 1];
  return `${first} ${last.charAt(0).toUpperCase()}.`;
}

/**
 * ISO timestamp -> "M.D.YY"  (e.g. "2026-04-24T21:48:53Z" -> "4.24.26")
 */
export function formatNoteDate(value) {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) {
    // Plain "YYYY-MM-DD" fallback when the input isn't a full ISO timestamp.
    if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}/.test(value)) {
      const [y, m, day] = value.slice(0, 10).split("-");
      return `${parseInt(m, 10)}.${parseInt(day, 10)}.${y.slice(-2)}`;
    }
    return "";
  }
  return `${d.getMonth() + 1}.${d.getDate()}.${String(d.getFullYear()).slice(-2)}`;
}
